import { CircleCheck, CircleDashed, MoveRight, OctagonX, TrendingUp, type LucideIcon } from 'lucide-preact'
import { SENDING_DOMAIN_PILL_LABELS, sendingDomainPill, type SendingDomainPill } from '@/types/sendingDomains'

// Green now means Ready, so nothing else on these screens (the Default chip included) is drawn green.
const PILL_STYLES: Record<SendingDomainPill, { className: string; Icon: LucideIcon }> = {
  SettingUp: { className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300', Icon: CircleDashed },
  Warming: { className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300', Icon: TrendingUp },
  Holding: { className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300', Icon: MoveRight },
  Ready: { className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300', Icon: CircleCheck },
  Stopped: { className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300', Icon: OctagonX },
}

interface DomainStatePillProps {
  domain: { State: string; WarmupHoldReason?: string | null }
}

/** The state's icon on its own, for the status box that leads a domain's page. */
export function DomainStateIcon({ pill, className = '' }: { pill: SendingDomainPill; className?: string }) {
  const { Icon } = PILL_STYLES[pill]
  return <Icon className={className} aria-hidden="true" />
}

/** A domain's warm-up state (Setting up, Warming, Holding, Ready, Stopped), the headline on every sending-domain screen. */
export function DomainStatePill({ domain }: DomainStatePillProps) {
  const pill = sendingDomainPill(domain)
  if (!pill) return null
  const { className, Icon } = PILL_STYLES[pill]
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${className}`}>
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      {SENDING_DOMAIN_PILL_LABELS[pill]}
    </span>
  )
}
